"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var next_components_1 = require("@dotdev/next-components");
var Snippets = require("snippets");
var MobileNavigation = /** @class */ (function (_super) {
    __extends(MobileNavigation, _super);
    function MobileNavigation(props) {
        var _this = _super.call(this, props) || this;
        _this.scrollableNav = React.createRef();
        _this.buildList = function (linklist, level) {
            var levels = {
                1: (React.createElement("ul", { className: "list-reset overflow-y-hidden overflow-x-auto no-scrollbars transition-slow relative flex flex-col flex-no-wrap items-center list-reset level-" + level + " " + (_this.props.visible ? "translate-x:0 transition-delay-0 opacity-100" : "translate-x:100 transition-delay-25 opacity-0"), ref: _this.scrollableNav },
                    linklist.links ? _this.buildItems(linklist.links, level) : null,
                    React.createElement("div", { className: "absolute pin-b h-0 border-b invisible border-" + (_this.state.highlighted ? "highlight" : "midnight") + " transition-fast", style: {
                            left: _this.state.borderLeft,
                            width: _this.state.borderWidth
                        } }))),
                2: (React.createElement("ul", { key: linklist.handle, className: "w-full overflow-hidden transition-fast bg-arctic pl-0 " + (_this.state.active == linklist.handle
                        ? "visible opacity-100 transition-delay-25 translate-y:0"
                        : "invisible opacity-0 transition-delay-0 max-h-0 translate-y:20x") }, linklist.links ? _this.buildItems(linklist.links, level) : null))
                // 3: <ul className={`list-reset`}>{linklist.links ? this.buildItems(linklist.links, level) : null}</ul>
            };
            return levels[level];
        };
        _this.buildItems = function (links, level) {
            return links
                ? links
                    .filter(function (item) { return !item.title.includes("[featured]"); })
                    .map(function (link, i) {
                    var children = link.links && link.links.length;
                    var levels = {
                        1: (React.createElement(React.Fragment, { key: i },
                            React.createElement("li", { key: i, className: "w-full block " + (link.title == "Clearance" ? "bg-red" : "") },
                                _this.buildLink(link, level, children, i),
                                children && _this.buildList(link, level + 1)))),
                        2: (React.createElement(React.Fragment, { key: i },
                            React.createElement("li", { key: i, className: "block" }, _this.buildLink(link, level, children, i)),
                            children && _this.buildList(link, level + 1)))
                    };
                    return levels[level];
                })
                : [];
        };
        _this.buildLink = function (link, level, children, index) {
            var highlighted = false;
            var levels = {
                1: (React.createElement("div", { className: "leading-looser " + _this.state.active },
                    React.createElement("a", { href: link.url, title: link.heading, onClick: children ? function (event) { return _this.toggleActive(link.handle, highlighted); } : null, className: "flex items-center no-underline text-base font-semibold font-body py-1-2 px-2-4 transition-fast whitespace-no-wrap border-b " + (!_this.state.active && index === 0 ? "border-transparent" : "border-transparent") + " " + (_this.state.active == link.handle || (!_this.state.active && index === 0) ? "text-arctic" : "text-arctic") },
                        React.createElement("span", { className: "flex-grow" }, link.title),
                        children ? (React.createElement("span", { className: "flex justify-end items-end transition-fast " + (_this.state.active == link.handle ? "rotate:180" : "") },
                            React.createElement(Snippets.Svg, { name: "chevron-down", width: 12 }))) : null))),
                2: (React.createElement(Snippets.Link, { href: link.url, title: link.heading, colour: "midnight", className: "flex items-center border-b border-grey-light text-base leading-normal text-navy no-underline py-2\n          px-2-4 font-semibold" }, link.title))
            };
            return levels[level];
        };
        _this.toggleActive = function (handle, highlighted) {
            event.preventDefault();
            var newHandle = _this.state.active === handle ? null : handle;
            if (newHandle) {
                var item = ReactDOM.findDOMNode(event.target);
                var nav = _this.scrollableNav.current;
                var active = newHandle;
                var scrollPosition = item.offsetLeft + item.offsetWidth / 3 - nav.offsetWidth / 2;
                _this.setState({
                    active: newHandle,
                    highlighted: highlighted,
                    borderWidth: item.offsetWidth,
                    borderLeft: item.offsetLeft
                });
                nav.scrollTo({ left: scrollPosition, behavior: "smooth" });
            }
            else {
                _this.setState({
                    active: newHandle,
                    borderLeft: 0,
                    borderWidth: 0
                });
            }
        };
        _this.state = {
            active: null,
            highlighted: false,
            borderLeft: 0,
            borderWidth: 0
        };
        return _this;
    }
    MobileNavigation.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, linklist = _a.linklist, searchValue = _a.searchValue, secondaryLinklist = _a.secondaryLinklist, theme = _a.theme, visible = _a.visible;
        var customer = this.props.customer;
        return (React.createElement("nav", { className: "bg-native fixed pin pin-y flex flex-col lg:hidden h-full-h w-full max-w-full z-20 transition-fast border overflow-y-auto " + (visible ? "visible pointer-events-auto transition-delay-0" : "invisible pointer-events-none transition-delay-5") },
            React.createElement(Snippets.Container, { className: "py-1-1 pointer-events-none invisible opacity-0 border hidden" },
                React.createElement("div", { className: "block w-2/3 md:w-1/3 max-w-17 pb-3" },
                    React.createElement(Snippets.MobileMenu, __assign({}, this.props, { toggleMobileNav: this.toggleMobileNav, visible: this.state.menuOpen })))),
            linklist && linklist.links ? (React.createElement("div", { className: "bg-native transition-fast pt-5-5 " + (visible ? "translate-y:0 transition-delay-0" : "translate-y:-100 transition-delay-0") }, this.buildList(linklist, 1))) : null,
            React.createElement(Snippets.Container, { className: "text-arctic pt-1-4 pb-4-4 transition-fast " + (visible ? "translate-y:0 transition-delay-25" : "translate-y:200 transition-delay-0") },
                React.createElement("ul", { className: "list-reset flex flex-col items-center justify-around" },
                    React.createElement("li", { className: "block p-1-6 w-full" },
                        React.createElement("button", { onClick: function () { return _this.props.customerStep("login"); }, title: "Account", className: "flex items-center justify-center text-arctic hover:text-grey-mid" },
                            React.createElement(Snippets.Svg, { name: "user", width: 16, className: "block mr-0-8" }),
                            React.createElement("p", { className: "text-sm font-medium" }, "Account"))),
                    Object.keys(this.props.data.customer).length != 0 ? (React.createElement("li", { className: "block p-1-6 w-full" },
                        React.createElement(Snippets.Link, { href: "/apps/toolkit/wishlist/" + this.props.data.customer.id, title: "Wishlist", colour: "arctic", hoverColour: "grey-mid", className: "flex text-arctic" },
                            React.createElement("span", null,
                                React.createElement(Snippets.Svg, { name: "star", height: 16, width: 16, className: "inline-block  mr-0-8" })),
                            React.createElement("span", { className: "text-sm font-medium pb-0-2" }, "Wishlist")))) : null,
                    React.createElement("li", { className: "block p-1-6 w-full" },
                        React.createElement(Snippets.Link, { href: "/pages/store-locator", title: "Stores", colour: "arctic", hoverColour: "grey-mid", className: "flex text-arctic" },
                            React.createElement("span", null,
                                React.createElement(Snippets.Svg, { name: "location", height: 16, width: 16, className: "inline-block  mr-0-8" })),
                            React.createElement("span", { className: "text-sm font-medium pb-0-2" }, "Stores")))))));
    };
    MobileNavigation.contextType = next_components_1.ShopifyNext.Context;
    return MobileNavigation;
}(React.PureComponent));
exports.MobileNavigation = MobileNavigation;
